import React from 'react';

export const TrendingDown = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g mask="url(#mask0_210_4446)">
      <path
        d="M13.3334 15V13.3333H15.5L11.1667 9.04167L7.83335 12.375L1.66669 6.16667L2.83335 5L7.83335 10L11.1667 6.66667L16.6667 12.1667V10H18.3334V15H13.3334Z"
        fill={color || '#7D7A9A'}
      />
    </g>
  </svg>
);
